export default "__VITE_ASSET__ClBoMjoV__"